import { render, staticRenderFns } from "./HisInformationEditor.vue?vue&type=template&id=47756cf1&scoped=true&"
import script from "./HisInformationEditor.vue?vue&type=script&lang=ts&"
export * from "./HisInformationEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47756cf1",
  null
  
)

export default component.exports